import InboomaBaseAsyncCollection from "./InboomaBaseAsyncCollection";
import Network from "../models/Network";

export default InboomaBaseAsyncCollection.extend({
  collectionName: "networks",
  model: Network,
  url: "/networks",

  _pagination: {
    // Updated after each request (response.pagination)
    current_page: 0,
    sort: "created",
    sortDirection: "desc",
    has_next_page: false,
    has_prev_page: false,
    count: 0, // not relevant; response total entities count
    limit: 500,
  },
});
